<template>
  <section-page
    title="Pending Invitations"
  >
    <app-loading-section
      :loading="isLoading"
      :count="users.length"
      heading="There are no pending invites"
    >
      <table-default
        :table-data="users"
        :default-sort="['created_at', 'desc']"
      >
        <b-table-column label="Email Address" field="email_address" sortable v-slot="props">
          {{ props.row.email_address }}
        </b-table-column>

        <b-table-column label="Sent On" field="created_at" sortable v-slot="props">
          {{ formatDate(props.row.created_at) }}
        </b-table-column>

        <b-table-column label="Expires On" field="expires_at" sortable v-slot="props">
          {{ formatDate(props.row.expires_at) }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="200" v-slot="props">
          <button-link :loading="isDeleting" @click="deleteInvite(props.row.id)">Delete</button-link>
        </b-table-column>
      </table-default>
    </app-loading-section>
  </section-page>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "UsersPendingInvites",
  props: {
    users: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isDeleting: false
    }
  },
  methods: {
    formatDate(timestamp) {
      return dates.formatAsDateTime(timestamp);
    },
    deleteInvite(userId) {
      return this.$utils.confirm(
        `Are you sure you want to cancel the invitation?`,
        `Cancel Invitation`
      ).then(() => {
        this.isDeleting = true;
        this.$api.userInvites.delete(userId)
          .then(() => {
            let index = this.users.findIndex(user => user.id === userId);
            this.users.splice(index, 1);

            this.$buefy.toast.open({
              message: 'The invitation has been deleted',
              type: 'is-success'
            });
          })
          .finally(() => this.isDeleting = false);
      });
    },
  }
}
</script>

<style scoped>

</style>
